exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".youtubevideo-container{height:100%;background:#000}", ""]);

